import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className="footer">
      Made with ❤️ by
      {' '}
      <a
        target="_blank"
        href="https://www.linkedin.com/in/r36/"
        rel="noreferrer"
        className="footer__link"
      >
        &nbsp;Rebaz Farid Noori
      </a>
    </div>
  );
}
